"use strict";Object.defineProperty(exports, "__esModule", {value: true});// The org setting "Don't allow users to see patient phone numbers" makes the
// server send users who aren't admins a masked number instead of the real one,
// for example `•••-•••-0142` (or `••••` when there are four digits or fewer).
// The mask can turn up anywhere a patient number can: the Phone field, a name
// or chat title that falls back to the number, search results.
//
// A masked value is display text, not a phone number. Render it verbatim:
// don't format it, parse it into a phone input, or build a `tel:`/`sms:` link,
// a call or text action, or a copy-number action from it.

const PHONE_MASK_CHAR = '•' // •

 const isMaskedPhone = (value) =>
  !!value && value.includes(PHONE_MASK_CHAR); exports.isMaskedPhone = isMaskedPhone
